import ExplainerSwitch from "@/features/explainers/components/ExplainerSwitch";
import type { DiaryKeyT } from "@/types/database/diaries";
import { createFileRoute } from "@tanstack/react-router";

const ExplainerPage = () => {
	const { explainerType } = Route.useParams();
	return (
		<div>
			<ExplainerSwitch diaryType={explainerType as DiaryKeyT} />
		</div>
	);
};

export const Route = createFileRoute("/_website/help/explainer/$explainerType")(
	{
		component: ExplainerPage,
	},
);
